import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import WhatsApp from "@mui/icons-material/WhatsApp";
import PhoneRounded from "@mui/icons-material/PhoneRounded";
import ZoomInRounded from "@mui/icons-material/ZoomInRounded";
import CloseRounded from "@mui/icons-material/CloseRounded";

import { PhoneNumberWA, PhoneNumberCall } from "../../context/Context";

import TableDescription from "../TableDescription/TableDescription";
import "./Card.css";

const CardBox = (props) => {
  const { value } = props;
  const isLiquid = value.nameMachine.toLowerCase().includes("liquid");
  const [imageOpen, setImageOpen] = useState(false);
  const imageUrl = `${process.env.PUBLIC_URL}/assets/images/${value.id}.png`;

  const getWhatsappMessage = () => {
    return encodeURIComponent(
      `Halo Jaya Sukses Pratama, saya ingin bertanya tentang mesin ${value.nameMachine}. Mohon informasi dan rekomendasinya.`
    );
  };

  return (
    <>
      <Card className="product-card" variant="outlined">
        <Box
          component="button"
          type="button"
          className="product-image-wrap"
          onClick={() => setImageOpen(true)}
          aria-label={`Lihat gambar besar ${value.nameMachine}`}
        >
          <span className={`product-badge ${isLiquid ? "is-liquid" : ""}`}>
            {isLiquid ? "Liquid" : "Powder & granule"}
          </span>
          <CardMedia
            component="img"
            className="product-image"
            alt={`Mesin ${value.nameMachine}`}
            image={imageUrl}
            loading="lazy"
          />
          <span className="image-view-hint">
            <ZoomInRounded fontSize="small" />
            Lihat gambar
          </span>
          <span className="product-number">
            {String(value.id).padStart(2, "0")}
          </span>
        </Box>

        <CardContent className="product-content">
          <Typography component="h3" className="product-title">
            {value.nameMachine}
          </Typography>
          <TableDescription spec={value.specification} />
        </CardContent>

        <CardActions className="card-action">
          <Button
            href={`tel:${PhoneNumberCall}`}
            variant="outlined"
            className="call-button"
            startIcon={<PhoneRounded />}
          >
            Telepon
          </Button>
          <Button
            className="btn-whatsapp"
            href={`https://wa.me/${PhoneNumberWA.replace(
              "+",
              ""
            )}?text=${getWhatsappMessage()}`}
            target="_blank"
            rel="noreferrer"
            variant="contained"
            startIcon={<WhatsApp />}
          >
            Tanya mesin
          </Button>
        </CardActions>
      </Card>

      <Dialog
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        maxWidth="md"
        fullWidth
        className="image-dialog"
        aria-labelledby={`image-dialog-title-${value.id}`}
      >
        <Box className="image-viewer">
          <IconButton
            className="image-viewer-close"
            onClick={() => setImageOpen(false)}
            aria-label="Tutup gambar"
          >
            <CloseRounded />
          </IconButton>
          <Box className="image-viewer-stage">
            <img src={imageUrl} alt={`Tampilan besar mesin ${value.nameMachine}`} />
          </Box>
          <Box className="image-viewer-caption">
            <Typography
              component="h2"
              id={`image-dialog-title-${value.id}`}
            >
              {value.nameMachine}
            </Typography>
            <Typography component="p">
              Gambar produk dan contoh hasil kemasan
            </Typography>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default CardBox;
